import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import Button from './Button';

interface Props {
  htmlId?: string;
  text: string;
  onClick: (formData: FormData) => void;
  onError: (error: string) => void;
  className?: string;
  disabled?: boolean;
  icon?: string;
  title?: string;
  btnClass?: string;
  wrapperId?: string;
  style?: React.CSSProperties;
}

const MaxSize = 30 * 1024 * 1024;

const FileUploadButton: React.FC<Props> = ({
  htmlId,
  text,
  onClick,
  onError,
  className,
  disabled = false,
  icon,
  title,
  btnClass,
  wrapperId,
  style,
}) => {
  const upload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (!file) {
      return;
    }

    if (file.size > MaxSize) {
      onError('oversize');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    e.target.value = '';
    onClick(formData);
  };

  // eslint-disable-next-line no-unneeded-ternary

  return (
    <div className={`upload-btn-wrapper ${className}`} id={wrapperId}>
      <Button
        htmlId={htmlId}
        text={text}
        icon={(icon as IconProp) || 'arrow-circle-up'}
        className={`btn-tertiary ${btnClass}`}
        disabled={disabled}
        title={title}
        style={style}
      />
      <input type="file" onChange={upload} disabled={disabled} />
    </div>
  );
};

export default FileUploadButton;
